/**
 * 字体指令
 * 用法：v-font="value"
 * - 数字 → 自动应用 HONORSans 字体
 * - 文本 → 自动应用 AlibabaPuHuiTi 字体
 */
function isNumber(val) {
  if (val === null || val === undefined || val === '') return false
  var str = String(val).trim()
  return /^-?\d+\.?\d*$/.test(str)
}

function getFontFamily(val) {
  return isNumber(val)
    ? "'HONORSans', -apple-system, BlinkMacSystemFont, sans-serif"
    : "'AlibabaPuHuiTi', -apple-system, BlinkMacSystemFont, sans-serif"
}

export var fontDirective = {
  bind: function(el, binding) {
    el.style.fontFamily = getFontFamily(binding.value)
  },
  update: function(el, binding) {
    el.style.fontFamily = getFontFamily(binding.value)
  }
}
